import { c as _c } from "react/compiler-runtime";
import type { RefObject } from "react";
import { useEffect, useState } from "react";
import { useIntersectionObserver } from "@/hooks/scroll/useIntersectionObserver";
interface UseSlideshowAutoplayReturn {
  isInViewport: boolean;
  setSwiperInstance: (swiper: any) => void;
}
export function useSlideshowAutoplay(slideshowRef) {
  const $ = _c(11);
  const [isInViewport, setIsInViewport] = useState(false);
  const [swiperInstance, setSwiperInstance] = useState(null);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      threshold: 0.3
    };
    t1 = entry => setIsInViewport(entry.isIntersecting);
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useIntersectionObserver(slideshowRef, t0, t1);
  let t2;
  let t3;
  if ($[2] !== swiperInstance) {
    t2 = () => {
      if (swiperInstance?.autoplay) {
        swiperInstance.autoplay.stop();
      }
    };
    t3 = [swiperInstance];
    $[2] = swiperInstance;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  if ($[5] !== isInViewport || $[6] !== swiperInstance) {
    t4 = () => {
      if (swiperInstance?.autoplay) {
        if (isInViewport) {
          swiperInstance.autoplay.start();
        } else {
          swiperInstance.autoplay.stop();
        }
      }
    };
    t5 = [isInViewport, swiperInstance];
    $[5] = isInViewport;
    $[6] = swiperInstance;
    $[7] = t4;
    $[8] = t5;
  } else {
    t4 = $[7];
    t5 = $[8];
  }
  useEffect(t4, t5);
  let t6;
  if ($[9] !== isInViewport) {
    t6 = {
      isInViewport,
      setSwiperInstance
    };
    $[9] = isInViewport;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
}